import React from 'react';
import { IconLocalShipping } from '@tvg/fuse/icon/all';
import { IconElement } from '@tvg/fuse/icon-element';
import { Modal } from '@tvg/fuse/modal';
import { DeliveryAndReturnsDialogProps } from '../DeliveryAndReturnsProps';
import styles from './DeliveryAndReturnsDialog.module.css';

function DeliveryAndReturnsDialog(props: DeliveryAndReturnsDialogProps) {
  const { body, brand, brandLogoUrl, heading, onClose, open } = props;

  return (
    <Modal
      className={styles.modal}
      dataTestId="delivery-and-returns-dialog"
      headerIcon={
        <IconElement
          icon={<IconLocalShipping />}
          responsiveSize="small"
          color="var(--color-brand-mid)"
          srLabel="Delivery"
        />
      }
      name="delivery-and-returns-dialog"
      onClose={onClose}
      open={open}
      srLabelCloseButton="Close delivery and returns dialog"
      title={heading}
      titleTag="h2"
      zIndex="20"
    >
      {brand && brandLogoUrl && (
        <img
          src={brandLogoUrl}
          width="auto"
          alt={`${brand} brand logo`}
          data-testid="delivery-and-returns-brand-logo"
          className={styles.brandLogo}
        />
      )}
      <div
        className={styles.body}
        data-testid="delivery-and-returns-dialog-body"
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </Modal>
  );
}

export default DeliveryAndReturnsDialog;
